export type RouteName = "home" | "play" | "story-edit" | "character-edit";

export interface Route {
  name: RouteName;
  params: Record<string, string>;
}

export function parseHash(hash: string): Route {
  const path = hash.replace(/^#/, "") || "/";
  const parts = path.split("/").filter(Boolean);

  if (parts[0] === "play" && parts[1]) {
    return { name: "play", params: { id: decodeURIComponent(parts[1]) } };
  }
  if (parts[0] === "edit" && parts[1] === "story") {
    return {
      name: "story-edit",
      params: { id: parts[2] ? decodeURIComponent(parts[2]) : "" },
    };
  }
  if (parts[0] === "edit" && parts[1] === "character") {
    return {
      name: "character-edit",
      params: { id: parts[2] ? decodeURIComponent(parts[2]) : "" },
    };
  }
  return { name: "home", params: {} };
}

export function navigate(path: string): void {
  if (window.location.hash === `#${path}`) {
    window.dispatchEvent(new Event("hashchange"));
    return;
  }
  window.location.hash = path;
}

export function subscribe(onHash: (route: Route) => void): () => void {
  const handler = (): void => {
    onHash(parseHash(window.location.hash));
  };
  window.addEventListener("hashchange", handler);
  handler();
  return () => window.removeEventListener("hashchange", handler);
}
